<template>
  <div class="">
    <vs-tabs class=" menu-main-wrap menu-nav">
      <vs-tab label="Categories">
        <menu-general :restaurantId="restaurantId" />
      </vs-tab >
      <vs-tab label="Products">
          <menu-products :restaurantId="restaurantId" />
      </vs-tab>
      <vs-tab label="Modifiers">
        <menu-modifiers :restaurantId="restaurantId" />
      </vs-tab>
      <vs-tab label="Sizes">
        <menu-sizes :restaurantId="restaurantId" />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import MenuGeneral from '../MenuGeneral.vue'
import MenuProducts from '../MenuProducts.vue'
import MenuModifiers from '../MenuModifiers.vue'
import MenuSizes from '../MenuSizes'

export default{
  props: {
    restaurantId: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  beforeMount () {
    this.resId = this.restaurantId
  },
  components: {
    MenuModifiers,
    MenuSizes,
    MenuProducts,
    MenuGeneral
  },
  data () {
    return {
      resId: ''
    }
  }
}
</script>
